import {  QUERY_GET_VEHICLES,QUEY_GET_MASTER_COUNT} from '../../fetch/constantQueries'
import { baseThunk } from '../../fetch/basicThunk';

export const postVehicleList = baseThunk("vehicleList/postVehicleList", QUERY_GET_VEHICLES, "GET");
export const postVehicleCount = baseThunk("vehicleList/postVehicleListCount",QUEY_GET_MASTER_COUNT,"GET");